import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useIsMobile } from '@niaratech/niara-react-components/src';
import { IcGallery } from '../../Icons';
import Gallery from '../Gallery';
import SlideShow from '../SlideShow';
import ImageViewer from '../ImageViewer';
import ModalOTA from '../ModalOTA';
import * as S from './styles';
type Props = {
  dataGallery?: string[];
  style?;
  roundImg?: string;
  className?;
  corner?: boolean;
  showNumberOfImages?: boolean;
  showNavigation?: boolean;
  galleryPortalElement?: HTMLElement; // passa o elemento onde deseja renderizar o modal da galeria. Se não passar, renderiza no proprio componente
  title?: string;
};
const ThumbWithGallery: React.FC<React.PropsWithChildren<Props>> = props => {
  const {
    dataGallery,
    style,
    className,
    children,
    corner,
    roundImg,
    showNumberOfImages = true,
    showNavigation = true,
    galleryPortalElement,
    title
  } = props;
  const [openGallery, setOpenGallery] = useState(false);
  const isMobile = useIsMobile();
  if (!dataGallery) return null;
  const galleryElement = dataGallery && openGallery && <Gallery dataGallery={dataGallery} onClose={() => setOpenGallery(false)} />;
  const handleOpenGallery = () => {
    setOpenGallery(true);
  };
  return <>
      {isMobile ? null : galleryPortalElement ? createPortal(galleryElement, galleryPortalElement) : galleryElement}
      {dataGallery && openGallery && (isMobile ? <ModalOTA padding="0" show={openGallery} mobileVariant="full" closeButtonColor="white" backgroundColor="black" setShow={setOpenGallery} title={title} zIndex={2147483648} stickyHeader render={() => <S.MobileModalContents>
                  <ImageViewer gallery={dataGallery} />
                </S.MobileModalContents>} /> : null) //<Gallery dataGallery={dataGallery} onClose={() => setOpenGallery(false)} />
    }
      <S.ThumbContainer style={style} className={className}>
        {dataGallery?.length > 0 && <S.Thumbnail src={dataGallery[0]} roundImg={roundImg} onClick={handleOpenGallery} />}
        {dataGallery?.length > 0 && showNumberOfImages && <S.ButtonGallery corner={corner} onClick={handleOpenGallery} className="button-gallery">
            <img src={IcGallery} alt="image-icon" />

            <p>{dataGallery?.length}</p>
          </S.ButtonGallery>}
        {children}
      </S.ThumbContainer>
    </>;
};
export default ThumbWithGallery;